import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'have_race_ethnic_group_skin_color_sex_gender_3'

export const dataPointDefinition = {
  retracedId: 'have_race_ethnic_group_skin_color_sex_gender_3',
  name: 'Have race, ethnic group, skin color, sex (gender), religion, political opinion, national extraction, social origin, disa',
  description:
    'Answer Yes if any of these elements are factored into decisions regarding promotion or access to training.',
  meta: {
    slcpMeta: {
      key: 'wt-dis-3',
      number: 'WT-DIS-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37270,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
